'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('dashboard.webhooks', {
            url: '/webhooks',
            templateUrl: 'dashboard-webhooks/dashboard-webhooks.html',
            controller: 'dashboardWebhooksCtrl as ctrl',
            cache: false,
            resolve: {
                webhooks: ['Webhook', function(Webhook) {
                  return Webhook.find()
                      .$promise
                      .then(function(webhooks) {
                          return webhooks;
                      })
                      .catch(function (error) {
                        return error;
                      });
                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser']
            }
        });
};
